// delReportsLists/state.js

export const delReportsListsInitialState = {
  items: [],
  tableType: "reports",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedReport: null,
  selectedReportIds: [],
  hasMore: false,
  isFiltered: false,
};
